/// <reference path="appConfig.d.ts" />

const  uniq = require('lodash/uniq');
const groupBy= require('lodash/groupBy');
const get = require('lodash/get');

export const DEFAULT_COLOR_CSS = 'lib/app-colors.css';

let baseURI;

export class AuthenticationMethod {
	constructor(private _authenticationSystem : string,
				private _profileName : string,
				private _index: number) {

	}

	get profileName() {
		return this._profileName;
	}

	get authenticationSystem() {
		return this._authenticationSystem;
	}

	get index() {
		return this._index;
	}

	public isExternal() {
		if ( this._authenticationSystem === 'SAML' ||
			this._authenticationSystem === 'PDS' ||
			this._authenticationSystem === 'CAS'||
			this._authenticationSystem === 'SOCIAL_VIA_ALMA'){
			return 1;
		}
		else {
			return 0;
		}
	}

	public isSilentLoginSupported() {
		if ( this._authenticationSystem === 'SAML' ||
			this._authenticationSystem === 'PDS' ||
			this._authenticationSystem === 'CAS'){
			return true;
		}
		else {
			return false;
		}
	}
}

export function getAuthenticationMethods():  AuthenticationMethod[]{
	let methods = window.appConfig.authentication.map(
		(v,i,arr) => new AuthenticationMethod( v['authentication-system'], v['profile-name'], i)
	);
	return methods;

}

export function getBriefResultConfiguration() {
	return window.appConfig.tiles.ResultTileInterface;
}

export function getFacetConfiguration() {
	return window.appConfig.tiles.FacetTileInterface;
}

export function getLocationsConfiguration() {
	return window.appConfig.tiles.LocationsTileInterface;
}

export function getMainMenuConfiguration() {
	return window.appConfig.tiles.MainMenuTileInterface;
}

export function getFullViewConfiguration() {
	return window.appConfig.tiles.ResultFullTileInterface;
}

export function getBxEnable() {
	return window.appConfig['bx-enable'];
}


export function getSyndeticUnboundEnable() {
	return window.appConfig['syndeticunbound-enable'];
}
export function getSyndeticUnboundId() {
	return window.appConfig['syndeticunbound-id'];
}

export function getSystemConfiguration() {
	return window.appConfig['system-configuration'];
}

export function getInstitutionCode() {
	return window.appConfig['primo-view'].institution['institution-code'];
}

export function getNewspapersSearchEnabled(): boolean {
    return window.appConfig['primo-view'].institution['newspapers-search'];
}

export function getDisplayNewspapersLink(): boolean{
    return getAttributesMap()['displayNewspapersLink'];
}

export function getRefEntryActive(): boolean{
    return getAttributesMap()['refEntryActive'];
}

export function getDisplayFeaturedNewspapers(): boolean{
    return getAttributesMap()['displayFeaturedNewspapers'];
}

export function getInstitutionId() {
	return window.appConfig['primo-view'].institution['id'];
}

export function getBeaconInstitutionCode() {
    return window.appConfig['beacon']['alternative-institution-code'];
}

export function getFindInDbPerTabs() {
    return window.appConfig['primo-view']['showFindInDbPerTabs'];
}

export function getScopes() {
	function getScopeId(e) {
		return e['scope-id'];
	}
	let scopes = window.appConfig['primo-view'].scopes.map(getScopeId);
	return uniq(scopes);
}

export function getSearchConfiguration() {
	return window.appConfig.tiles.SearchTileInterface;
}

export function getQueryTerms() {
	return window.appConfig.queryTerms;
}

export function getTabToTiles(tab) {
	return window.appConfig['tab-to-tiles'][tab];
}

export function getUIComponents(): IUIComponents {
	return window.appConfig.UIComponents;
}

export function getBaseUrls(){
	return window.appConfig['base-urls'];
}

export function getScopeList() {
	return window.appConfig['primo-view'].scopes;
}

export function getDefaultScope(){
	return (getScopes().indexOf('default_scope') !== -1) ?  'default_scope' :getScopes()[0];
}

export function getResultsBulkSize() {
    if ((window.location.href.includes('/jsearch') || window.location.href.includes('/dbsearch') || window.location.href.includes('/collectionDiscovery')) && getBackendSystem() !== 'suprima') //if you are in atoz search state then bulk size is as follows
		return 20;
	else
		return parseInt(window.appConfig['system-configuration']['FE UI – Scrolling Threshold'] || '10');
}

export function getShowMoreThreshold() {
	return parseInt(window.appConfig['system-configuration']['Show More (replaces scrolling) Threshold'] || '50');
}

export function getAttributesMap() {
	return window.appConfig['primo-view']['attributes-map'];
}

export function isRedirectOnlyForAuthName(profileName) {
    let profile = window.appConfig['authentication'].filter((profile) => profile['profile-name'] && profileName == profile['profile-name']);
    if (profile[0] && profile[0]['redirect-only']) {
        return profile[0]['redirect-only'];
    }
    return "false"
}

export function isSaml(profileName) {
    let profile = window.appConfig['authentication'].filter((profile) => profile['profile-name'] && profileName == profile['profile-name']);
    if (profile[0] && profile[0]['authentication-system']) {
        return profile[0]['authentication-system'] === 'SAML';
    }
    return "false"
}

export function getSessionTimeoutParams() {
	//session timeout is in minutes
	return {
		userSessionTimeout: parseInt(window.appConfig['system-configuration']['Session Timeout'], 10),
		guestSessionTimeout: parseInt(window.appConfig['primo-view']['timeout']['guest-ui-timeout'], 10),
		sessionTimeoutURL: getAttributesMap().sessionTimeoutURL,
		warningTime: 120,
	};

}

export function getCaptcha(){
	let captchaConf = {isActiveCapcha: window.appConfig['system-configuration']['Activate Captcha [Y/N]'],
						public_key: window.appConfig['system-configuration']['Public Captcha Key']}
	return captchaConf;
}

export function getVid() {
	return window.appConfig.vid;
}

export function getTabs() {
	return window.appConfig['primo-view']['available-tabs'];
}

export function getTab(scope) {
	let defaultTab = 'default_tab';
	if (getBackendSystem() === 'suprima') {
		defaultTab = window.appConfig['primo-view'].scopes[0]['tab-id-for-scope-matching'];
	}
	let cur = window.appConfig['primo-view'].scopes.filter(function(obj) { return obj['scope-id'] === scope;});
	if (cur && cur.length > 0) {
		return cur[0]['tab-id-for-scope-matching'] || defaultTab;
	}
	return defaultTab;
}

export function getCurrentPCKey() {
	if(window.appConfig['mapping-tables'] &&
		window.appConfig['mapping-tables'].primo_central_institutions_unique_ids[0]){
		return window.appConfig['mapping-tables'].primo_central_institutions_unique_ids[0].source1 || '';
	}
}

export function getCurrentServer() {
	return window.location.host.replace(/\:.*/,'');
}

export function getCurrentVersionNumber(){
	if(this.getBackendSystem() === 'suprima'){
		return window.appConfig['system-configuration'].Alma_Version;
	} else if (window.appConfig['system-configuration'].Primo_Version_Number &&
		window.appConfig['system-configuration'].Primo_HotFix_Number){
		return window.appConfig['system-configuration'].Primo_Version_Number +
			'.' + window.appConfig['system-configuration'].Primo_HotFix_Number
	}
	else{
		return '4.0.0.0';
	}
}

export function getBeaconUrl(){
	return window.appConfig['system-configuration'].RUM_URL;
}

export function getSummonOverAlma(){
	return window.appConfig.summon_over_alma;
}

export function getSearchWithinJournalConfig(){
	return window.appConfig.searchWithinJournalConfig;
}

export function getBackendSystem(){
    if (get(window,'appConfig.backend_system')){
        return window.appConfig.backend_system;
    }
    if (!baseURI){
        baseURI = getBaseURI();
    }
    return baseURI.indexOf('discovery') > -1? 'suprima' : undefined;
}

function getBaseURI() {
    let baseElement = document.getElementsByTagName('base');
    return baseElement[0].getAttribute('href');

}

export function getPrimoShortDateFormat(){
	let confEntries = window.appConfig['mapping-tables']['General Configuration'];
	let shortDate = confEntries.filter(entry => entry.source1 === 'Short_Date_Format');
	return shortDate[0].target;
}

export function getPrimoLongDateFormat(){
	let confEntries = window.appConfig['mapping-tables']['General Configuration'];
	let longDate = confEntries.filter(entry => entry.source1 === 'Long_Date_Format');
	return longDate[0].target;
}

export function getIlsDateFormat(){
	return 'yyyyMMdd';
}

export function getUrlContext() {
	if(this.getBackendSystem() === 'suprima'){
		return 'discovery';
	}
	return 'primo-explore';
}

export function getSearchScopesMap(){
	if(!window.appConfig.searchScopesMap){
		window.appConfig.searchScopesMap = groupBy(getScopeList(), 'tab');
	}
	return window.appConfig.searchScopesMap;
}

export function updateSearchScopesMap(scopes) {
    window.appConfig['primo-view'].scopes = scopes;
    window.appConfig.searchScopesMap = groupBy(getScopeList(), 'tab');
}

export function getDisableCacheParameters() {
	if(this.getBackendSystem() === 'suprima'){
		return window.appConfig['system-configuration'].disable_cache;
	}
}


/**
 * API base url for current institution.
 * @returns string (empty string means its 'ovl')
 */
export function getApiBaseUrl(){
	let instCode = getInstitutionCode();
	let baseUrlsTable = window.appConfig['mapping-tables']['Institution Base URLs'];
	let baseUrlEntry = baseUrlsTable.filter( entry => entry.source1 === instCode && entry.source2 === 'api_base');
	if (baseUrlEntry.length > 0){
		return baseUrlEntry[0].target;
	}
	return '';
}

export function getRtlLanguages() {
	return new Set(['iw','he','ar']);
}

export function getPagingType() {
	return 'infinite_scroll';
	//return 'paging';
}

export function isCitationTrailsEnabled() :boolean{
	return Boolean(getAttributesMap()['citationTrailsEnabled']);
}

export function getCitationLinkerBaseURL() :string{
    return window.appConfig['institution-base-url'];
}

export function getSyndetixWithProxy(){
	return window.appConfig['system-configuration']['Proxy_Server']+'syndetics.com/index.php?client=';
}

export function getGoogWithProxy(){
	return window.appConfig['system-configuration']['Proxy_Server']+'books.google.com/books?bibkeys=';
}

export function getAutocompleteUrl() {
	return window.appConfig['system-configuration'].Auto_Complete_Server_URL + '/solr/ac';
}

export function getPrimoVeSkipDelivery(){
    return window.appConfig['system-configuration']['skip_delivery'];
}

export function getPrimoVeAlternativeEmailDigitalResourceSharing(){
    return window.appConfig['system-configuration']['manualAlternativeEmailRS'];
}

export function getPrimoSplitFacetsMaxWait(){
    return window.appConfig['system-configuration']['split_facets_max_wait'];
}

export function getPrimoVeSplitFacetsWaitInterval(){
    return window.appConfig['system-configuration']['split_facets_wait_interval'];
}

export function getAZLangages(){
	return window.appConfig['mapping-tables']['A-Z Languages'];
}

export function getSEOParamsMapping(){
	return window.appConfig['mapping-tables']['seo_params_mapping'];
}
export function getSEOParamsMappingParam(param){
	let seoMappingTable = this.getSEOParamsMapping();
    if (seoMappingTable){
        let titlePath = seoMappingTable.filter(entry => entry.source1 === param);
        if (titlePath&&titlePath[0]){
        	return titlePath[0].target;
        }
    }
    return '';
}


export function isEnableSingleLogout() {
   return window.appConfig['enableSingleLogout'];
}

export function isAutoSearchOnTabChange(){
	return getAttributesMap()['tabsRemote'] === 'true';
}

export function  getShowICPLicenseFooter(){
    return window.appConfig['system-configuration']['Show ICP License Footer'];
}

export function getPrimoVeSkipDelivery(){
    return window.appConfig['system-configuration']['skip_delivery'];
}

export function  getBlendFacetsSeparatelyConfig(){
	if (this.getBackendSystem() === 'suprima'){
        return false; //this option isn't supported currently in the primoVE backend
    }
	return window.appConfig['system-configuration']['blend facets separately']? window.appConfig['system-configuration']['blend facets separately'] === 'true' : true;
}

export function getLegantoTemplateUrl(): string{
    return getAttributesMap()['legantoURLTemplate'];
}

export function getMultilingualConfigurationEnabled(): boolean{
    return getAttributesMap()['multilingualConfigurationEnabled'];
}

export function getRequestItemAvailabilityCheckTimeout() {
	return parseInt(get(window,'appConfig["system-configuration"]["request item availability check timeout"]', '1')) *60 *1000;
}

export function isUnionCatalogNZView() {
    if (getBackendSystem() !== 'suprima'){
        return false; //this option isn't supported currently in the primo backend
    }
    let consortiaMembers = get(window.appConfig,"['mapping-tables']['consortia member codes']",[]);
    let isUnionView = get(window.appConfig,"['primo-view']['is-union-catalog-view']", false);
	return isUnionView &&  consortiaMembers.length > 0;
}

export function isUnionCatalogMemberView(){
    if (getBackendSystem() !== 'suprima'){
        return false; //this option isn't supported currently in the primo backend
    }
    let isUnionView = get(window.appConfig,"['primo-view']['is-union-catalog-view']", false);
    return isUnionView && !isUnionCatalogNZView();
}

export function getUnionViewScopeSuffix() {
	return get(window.appConfig, "['system-configuration']['unionViewScopeSuffix']");
}




// WEBPACK FOOTER //
// ./src/main/webapp/components/appConfig/appConfigForward.ts